import { useLeadsSheetStore } from "../../../../../../stores/LeadsStore";
import { Button, Skeleton, Stack, ThemeIcon } from "@mantine/core";
import LeftSheetBottom from "./LeftSheetBottom";
import MainBio from "./MainBio";
import InfosContact from "./InfosContact";
import { useLanguage } from "../../../../../../stores/LanguageStore";

const LeftSheet = () => {
  const lang = useLanguage((s) => s.language);
  const current = useLeadsSheetStore((s) => s.current);
  const setActiveTab = useLeadsSheetStore((s) => s.setActiveTab);
  const loading = useLeadsSheetStore((s) => s.loading);

  if (loading) {
    return (
      <Stack
        w={"20%"}
        h={"100%"}
        py={"sm"}
        px={"sm"}
        pr={"xs"}
        style={{
          transition: "all ease .3s",
          borderRadius: 16,
          overflow: "auto",
        }}
      >
        <Skeleton height={"60%"} />
        <Skeleton height={"60%"} />
        <Skeleton height={"100%"} />
      </Stack>
    );
  }

  return (
    <Stack
      w={"20%"}
      h={"100%"}
      py={"sm"}
      px={"sm"}
      pr={"xs"}
      pb={0}
      style={{ transition: "all ease .3s", borderRadius: 16, overflow: "auto" }}
    >
      <MainBio />

      <InfosContact />

      <InfosContact isCompany />
      {/* <Stack
        gap={0}
        h={"calc(100% - 80px)"}
        style={{ overflow: "auto" }}
        w={"100%"}
      >
        {fields.defaultFields.map((item, index) => (
          <LeadLeftBio
            key={item.field_id}
            defaultValue={item.defaultValue}
            label={item.name}
            field={item.field}
            fieldId={item.field_id}
            icon={getFieldIcon(item.field)}
            isLink={item?.defaultValue?.includes("http")}
            isTel={item?.field.includes("phone")}
            isMail={item?.field.includes("mail") && item?.field.includes("@")}
            isOrg={item?.field === "%company%"}
            companyInCharge={current?.company_has_person_in_charge}
            phoneInCharge={current?.phone_has_person_in_charge}
            disableEdit={
              !current?.permission?.write_permission || item?.readonly
            }
            company={current.properties.find((x) => x.id === 12)?.value}
          />
        ))}

        {fields?.customFields?.map((item, index) => (
          <LeadLeftBio
            key={item.field_id}
            defaultValue={item.defaultValue}
            label={item.name}
            field={item.field}
            fieldId={item.field_id}
            icon={getFieldIcon(item.field)}
            isLink={item?.defaultValue?.includes("http")}
            isTel={item?.field.includes("phone")}
            isMail={item?.field.includes("mail") && item?.field.includes("@")}
            isOrg={item?.field === "%company%"}
            disableEdit={
              !current?.permission?.write_permission || item?.readonly
            }
          />
        ))}
      </Stack> */}

      <Button
        variant="white"
        style={{
          border: "1px solid",
          borderColor:
            current?.programmations?.length > 0
              ? "var(--mantine-color-primary-6)"
              : "transparent",
        }}
        rightSection={
          <ThemeIcon variant="light" ml={"auto"} fz={15} fw={600}>
            {current?.programmations?.length}
          </ThemeIcon>
        }
        mih={50}
        justify="space-between"
        onClick={() => {
          setActiveTab("campaign");
        }}
      >
        {lang.leads.current_campaigns}
      </Button>

      <LeftSheetBottom current={current} />
    </Stack>
  );
};

export default LeftSheet;
